import { render, staticRenderFns } from "./SoftwareOffersList.vue?vue&type=template&id=0593497e"
import script from "./SoftwareOffersList.vue?vue&type=script&lang=ts"
export * from "./SoftwareOffersList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports